<template>
  <div class="cancelamento">
    <Topo @assinatura="selecionarAssinatura" />
    <div class="row">
      <div class="col-md-4 mt-3">
        <Menu />
      </div>
      <!-- Conteudo das views -->
      <div class="col-md-8 mt-3">
        <!-- conteudo views -->
        <div class="card" v-if="profile === 'HOLDER'">
          <div class="card-body">
            <h5 class="card-title mb-4">Solicitação de Cancelamento</h5>
            <div class="col-md-12 mb-2 mt-4">
              <h6 class="card-subtitle mb-2 text-muted">Qual o Motivo?</h6>
              <select class="form-control mb-1" v-model="reasonId" filterable placeholder="Motivo">
                <option :value="0">Selecione um motivo</option>
                <option v-for="option in reasons" :key="option.id" :label="option.description" :value="option.id">
                  {{ option.description }}
                </option>
              </select>
            </div>
            <div class="col-md-12 mb-2 mt-4">
              <h6 class="card-subtitle mb-2 text-muted">Motivo do cancelamento</h6>
              <textarea type="text" class="form-control" v-model="reasonCancel"
                placeholder="Conte para nós por qual motivo deseja cancelar" maxlength="255" />
            </div>
            <div class="col-md-12 text-center mt-3">
              <button type="button" class="btn btn-primary" @click="cancel">Solicitar Cancelamento</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Rodape />
  </div>
</template>

<script>
import Topo from '@/components/Topo.vue';
import Rodape from '@/components/Rodape.vue';
import Menu from '@/components/Menu.vue';

const optionsAlert = { title: 'Mensagem', size: 'sm' };

export default {
  name: 'cancel-subscription',
  components: {
    Topo, Menu, Rodape
  },
  mounted() {
    this.loadReason();
  },
  data() {
    return {
      profile: localStorage.getItem("profile"),
      subscription: { status: '' },
      reasons: [],
      reasonId: 0,
      reasonCancel: ""
    }
  },
  methods: {
    selecionarAssinatura(subscription) {
      this.subscription = subscription;
    },
    loadReason() {
      this.$clubApi.get('/support/reason/list/site')
        .then((response) => this.reasons = response.data.object)
        .catch((error) => this.$dialogs.alert(error.response.data.msg, optionsAlert));
    },
    cancel() {
      if (!this.reasonId || this.reasonCancel.trim() === '') {
        this.$dialogs.alert('Por favor, preencha todos os campos!', optionsAlert)
        return;
      }

      this.$clubApi.post(`/subscription/cancel/${this.subscription.id}`, {
        idreason: this.reasonId,
        reasonCancel: this.reasonCancel
      }).then((response) => this.$dialogs.alert(response.data.object, optionsAlert))
        .catch((error) => this.$dialogs.alert(error.response.data.msg, optionsAlert));
    }
  }
}
</script>
